module.exports = __webpack_public_path__ + "img/listView.0c568678.svg";